import React from "react";
import Tooltip from "./Tooltip";

const Button = React.forwardRef(
  (
    {
      children,
      variant = "primary",
      size = "medium",
      disabled = false,
      className = "",
      title,
      "aria-label": ariaLabel,
      ...props
    },
    ref
  ) => {
    const baseClasses = `
    inline-flex items-center justify-center
    font-medium rounded-md
    transition-all duration-200 ease-out
    focus:outline-none
    disabled:opacity-50 disabled:cursor-not-allowed
    select-none
  `;

    const variants = {
      primary: "menu-button",
      secondary: "menu-button",
      ghost: "menu-item ring-0 focus-visible:ring-0 focus-visible:outline-none",
      danger: "menu-button",
      transparent:
        "bg-transparent border border-gray-600 text-gray-200 hover:bg-gray-700 hover:border-gray-500",
    };

    const sizes = {
      small: "px-2 py-1 text-xs",
      medium: "px-3 py-2 text-sm",
      large: "px-4 py-2 text-sm",
    };

    const classes = `
    ${baseClasses}
    ${variants[variant]}
    ${sizes[size]}
    ${className}
  `;

    const button = (
      <button
        ref={ref}
        className={classes}
        disabled={disabled}
        aria-label={ariaLabel ?? title}
        {...props}
      >
        {children}
      </button>
    );

    return <Tooltip content={title}>{button}</Tooltip>;
  }
);

Button.displayName = "Button";

export default Button;
